import React, {MouseEventHandler, ReactElement, SyntheticEvent} from "react";
import {Button, ButtonProps, TextField, TextFieldProps} from "@mui/material";
interface CustomProps {
    //onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
    onClick: MouseEventHandler<HTMLInputElement>,
    href?:string,
    target?:string
    buttonContent:ReactElement
}

type EventHandler = (evt:SyntheticEvent) => void;
export function ButtonField(props) {
   /* const variant = props.fill ? 'standard' : 'outlined';
    return (<FormControl fullWidth={true}>
            <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
            <Button>Test</Button>
        </FormControl>
    );
}*/
    return <TextField
        variant="filled"
        multiline={false}
        size={props.size}
        InputLabelProps={{ shrink: true }}
        label={props.label??''}
        sx={(theme)=>({
            "& .MuiFilledInput-root":{
                alignItems: 'flex-end',
                justifyContent:'center',
                height:'100%'
            },
            '& a':{
                height: '100%',
                width: '100%'
            }
        })
        }
        className={props.className??''}
        inputProps={{buttonContent:props.buttonContent,href:props.href,target:props.target}}
        InputProps={{
            ...props.InputProps,
            inputComponent: ButtonCustom as any
        }}
    />
}

const ButtonCustom = React.forwardRef<
    any,any
    >(function NumberInputRef(props:{
    name: string,
    value: number,
    autoFocus: boolean,
    onChange?: EventHandler,
    buttonContent?: ReactElement,
    onBlur?: EventHandler,
    onClick?:MouseEventHandler<HTMLInputElement>,
    className?: string,
    loading?:boolean,
    label:string,
    readOnly?: boolean
    href?:string,
    target?:string
},ref) {
    const doClick = (value)=>{
        if(props.onClick) {
            props.onClick({target: {name: props.name, value: value}} as any);
        }
    }
    console.log('BC props are',props);
    if(props.href) {
        return <Button
            variant="text"
            color="primary"
            component="a"
            size="small"
            ref={ref}
            href={props.href}
            target={props.target}
            {...({name: props.name} as any)}
            onClick={doClick}
        >{props.buttonContent}</Button>;
    }
    return <Button
        variant="contained"
        sx={{height:"100%"}}
        ref={ref}
        name={props.name}
        onClick={doClick}
    >{props.buttonContent}</Button>;
});

